import { render, staticRenderFns } from "./FreemiumAccounts.vue?vue&type=template&id=0abd07de&scoped=true&"
import script from "./FreemiumAccounts.vue?vue&type=script&lang=js&"
export * from "./FreemiumAccounts.vue?vue&type=script&lang=js&"
import style0 from "./FreemiumAccounts.vue?vue&type=style&index=0&id=0abd07de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abd07de",
  null
  
)

export default component.exports